import { NgModule } from '@angular/core';
import {
  RouterModule,
  Routes,
} from '@angular/router';
import {
  RedirectCollabUrlGuard,
  RedirectLoginUrlGuard
} from '@lib/gc-common';
import { NetworkModule } from './modules/network.module';

const routes: Routes = [
  {
    path: 'app/tutorials',
    data: {
      smartBanner: false
    },
    loadChildren: () => import('./modules/tutorials/tutorials.module').then(m => m.TutorialsModule)
  },
  {
    path: 'dash/instagram',
    loadChildren: () => import('../../../gc-instagram-dash/src/app/app.module').then(m => m.AppModule),
  },
  {
    path: 'contact',
    loadChildren: () => import('./modules/contact/contact.module').then(m => m.ContactModule),
  },
  {
    path: 'dashboard',
    canActivate: [RedirectCollabUrlGuard],
    children: [{
      path: '**',
      loadChildren: () => import('./modules/home/home.module').then((m) => m.HomeModule)
    }]
  },
  {
    path: 'login',
    canActivate: [RedirectLoginUrlGuard],
    children: [{
      path: '**',
      loadChildren: () => import('./modules/home/home.module').then((m) => m.HomeModule)
    }]
  },
  {
    path: '',
    loadChildren: () => NetworkModule
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
